import Spinner from "./Spinner.jsx";


export default function LoadingComponent({loading, children, className, loadedClassName, spinnerType = 'spinner-medium'}) {

    let containerClassName = loading ? 'relative pointer-events-none select-none' : 'relative';

    let spinnerClassName = loading ? 'w-full h-full absolute flex' : 'hidden';

    let contentClassName = loading ? 'opacity-50' : loadedClassName;

    return <div className={containerClassName + ' ' + className}>
        <div className={spinnerClassName}>
            <Spinner size={spinnerType} className='m-auto'/>
        </div>
        <div className={contentClassName}>
            {children}
        </div>
    </div>;

}